import { render } from "./UserList.vue?vue&type=template&id=bdc44d42&scoped=true&ts=true"
import script from "./UserList.vue?vue&type=script&lang=ts"
export * from "./UserList.vue?vue&type=script&lang=ts"

import "./UserList.vue?vue&type=style&index=0&id=bdc44d42&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bdc44d42"]])

export default __exports__